module.exports = __webpack_public_path__ + "assets/src/style/img/footer-rug.png?f8190db417493d93e70ea41283779549";